<template>
  <div>
    <a-card :title="$t('cardTitle.howToEditChurchProfile')" class="reset-padding style1" v-if="!isAdmin">
      <iframe src="https://player.vimeo.com/video/465871855" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
    </a-card>
    <a-card :title="$t('cardTitle.' + (isAdmin ? 'editChurchProfile' : 'editYourChurchProfile'))" :class="`style1 profile ${isDesktop ? 'desktop' : 'mobile'}`">
      <a-form :form="form" :label-col="isDesktop ? { span: 4 } : {}" :wrapper-col="isDesktop ? { span: 20 } : {}" :layout="isDesktop ? 'horizontal' : 'vertical'" @submit="handleSubmit">
        <a-form-item :label="$t('label.churchDescription')">
          <wysiwyg
            v-model="profile_description"
            v-decorator="[
              'profile_description',
              {
                rules: [
                  {
                    required: true,
                    validator: (rule, value, callback) => validateInput(rule, value, callback, $t('placeholder.pleaseInputChurchDescription')),
                  },
                ],
              },
            ]"
          />
          <!-- <a-input
            v-decorator="['address', { rules: [{ required: true, message: 'Please input your address!' }] }]"
          />-->
        </a-form-item>
        <a-form-item :label="$t('label.videoEmbed')">
          <a-textarea v-decorator="['profile_video_embed']" :rows="4" />
        </a-form-item>
        <a-form-item :label="$t('label.serviceTimes')">
          <wysiwyg v-model="profile_service_times" v-decorator="['profile_service_times']" />
        </a-form-item>
        <a-form-item :label="$t('label.website')">
          <a-input placeholder="Website Address" v-decorator="['profile_website', { rules: [{ required: true, message: 'Please input website address!' }] }]" />
          <a-checkbox v-decorator="['use_profile_link']">
            Use this website for the link underneath the welcome video and Jesus Story and bypass the True Life Church Profile.
          </a-checkbox>
        </a-form-item>
        <a-form-item :label="$t('label.phone')">
          <a-input placeholder="Phone number" v-decorator="['cell_phone', { rules: [{ required: true, message: 'Please input phone number!' }] }]" />
        </a-form-item>
        <a-form-item :label="$t('label.facebook')">
          <a-input v-decorator="['profile_facebook']" />
        </a-form-item>
        <a-form-item :label="$t('label.twitter')">
          <a-input v-decorator="['profile_twitter']" />
        </a-form-item>
        <a-form-item :label="$t('label.profileBannerPicture')">
          <div :class="[coverImage.length === 0 && 'gallery']" class="select-from-gallery">
            <a v-if="coverImage.length === 0" href="javascript:void(0)" @click="imagePickerVisible = true">Or select from gallery</a>
            <a-upload
              v-decorator="['profile_cover_art']"
              action
              list-type="picture-card"
              :file-list="coverImage"
              @preview="file => handlePreview(file, 'coverImage')"
              :before-upload="beforeUpload"
              @change="({ fileList }) => handleChange({ fileList }, 'coverImage')"
              class="coverImage"
            >
              <div v-if="coverImage.length === 0">
                <a-icon type="plus" />
                <div class="ant-upload-text">{{ $t('button.upload') }}</div>
              </div>
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item :label="$t('label.pastorsHeadshot')">
          <a-upload
            v-decorator="['profile_headshot']"
            action
            list-type="picture-card"
            :file-list="headshotImage"
            :before-upload="beforeUpload"
            @preview="file => handlePreview(file, 'headshotImage')"
            @change="({ fileList }) => handleChange({ fileList }, 'headshotImage')"
            class="headshotImage"
          >
            <div v-if="headshotImage.length === 0">
              <a-icon type="plus" />
              <div class="ant-upload-text">{{ $t('button.upload') }}</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
          <a-button type="primary" html-type="submit" :loading="isLoading">{{ $t('button.updateAccount') }}</a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal :visible="previewVisible" :closable="false" class="editProfile">
      <a-spin v-if="isLoadingCropper" size="large" />
      <cropper
        v-if="previewImage != null"
        ref="cropper"
        class="cropper"
        :src="previewImage"
        @change="change"
        @ready="onCropperReady"
        :stencilProps="{
          aspectRatio: imgLocation === 'coverImage' ? 2.75 : 0.76,
        }"
        :defaultSize="defaultSize"
        :defaultPosition="defaultPosition"
      />
      <template slot="footer">
        <a-button key="back" @click="handleCancel">{{ $t('button.back') }}</a-button>
        <a-button key="submit" type="primary" @click="handleOk">{{ $t('button.submit') }}</a-button>
      </template>
    </a-modal>
    <image-picker :visible="imagePickerVisible" @onClosed="imagePickerVisible = false" @onSelected="handleSelectFromGallery" />
    <Loading :isLoading="isLoading" :type="typeLoading" :percent="percentLoading" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Cropper } from 'vue-advanced-cropper';
import Uploader from '@/services/UploadService';
import ImagePicker from './imagePicker';
import UserService from '@/services/UserService';
import AdminService from '@/services/AdminService';
import Loading from './loading';
import { empty, getBase64 } from '@/utils';
export default {
  props: {
    profile: {
      type: Object,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLoading: true,
    imagePickerVisible: false,
    previewVisible: false,
    isLoadingCropper: false,
    previewImage: '',
    coverImage: [],
    headshotImage: [],
    imgLocation: '',
    imageCropped: '',
    hasChange: {},
    hasCropped: {},
    profile_description: '',
    profile_service_times: '',
    typeLoading: 'submit',
    percentLoading: 0,
    useProfileLink: false,
  }),
  components: {
    ImagePicker,
    Cropper,
    Loading,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      name: 'editProfile',
    });
  },
  watch: {
    profile() {
      this.doInitData();
    },
  },
  computed: {
    ...mapState(['settings']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async mounted() {
    await this.doInitData();
    this.$title = this.$route.meta.title;
  },
  methods: {
    handleSelectFromGallery(url) {
      this.coverImage = [
        {
          uid: '-1',
          status: 'done',
          name: this.getFileName(url),
          url: url,
        },
      ];
      this.$nextTick(() => {
        this.handlePreview(this.coverImage[0], 'coverImage');
        this.imagePickerVisible = false;
      });
    },
    async doInitData() {
      let resp = [];
      if (this.isAdmin) {
        resp = this.profile;
      } else {
        resp = await UserService.doGetUserInfo();
      }
      this.profile_description = resp.profile_description;
      this.profile_service_times = resp.profile_service_times;
      this.coverImage = [];
      this.headshotImage = [];
      if (!empty(resp.profile_cover_art)) {
        this.coverImage.push({
          uid: '-1',
          status: 'done',
          name: this.getFileName(resp.profile_cover_art),
          url: resp.profile_cover_art,
        });
      }
      if (!empty(resp.profile_headshot)) {
        this.headshotImage.push({
          uid: '-1',
          status: 'done',
          name: this.getFileName(resp.profile_headshot),
          url: resp.profile_headshot,
        });
      }

      this.isLoading = false;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          profile_description: this.profile_description,
          profile_service_times: this.profile_service_times,
          profile_video_embed: resp.profile_video_embed,
          profile_website: resp.profile_website,
          use_profile_link: resp.use_profile_link,
          cell_phone: resp.cell_phone,
          profile_twitter: resp.profile_twitter,
          profile_facebook: resp.profile_facebook,
          profile_headshot: this.headshotImage[0],
          profile_cover_art: this.coverImage[0],
        });
      });
    },
    defaultSize() {
      return this.imgLocation === 'coverImage' ? { width: 10000, height: 10000, minHeight: 341, minWidth: 937 } : { width: 10000, height: 10000, minHeight: 250, minWidth: 190 };
    },
    validateInput(rule, value, callback, message) {
      if (empty(value) || value === '<br>') {
        return callback(message);
      }
      callback();
    },
    defaultPosition() {
      return {
        left: 0,
        top: 0,
      };
    },
    getFileName(path) {
      let fileName = '';
      // eslint-disable-next-line no-useless-escape
      const patt = /\/([^\\\/:*\"<>|]+)$/g;
      const n = patt.exec(path);
      if (n !== null) {
        fileName = n[1];
      }
      return fileName;
    },
    change({ canvas }) {
      if (canvas) {
        this.imageCropped = canvas.toDataURL('image/jpeg');
      }
    },
    handleUploadProgressing(percent, location) {
      this.percentLoading = percent;
      this.typeLoading = location;
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            // upload image
            // Profile Banner Picture
            const dataSubmit = {};
            if (this.hasChange['coverImage'] || this.hasCropped['coverImage']) {
              this.handleUploadProgressing(0, 'Profile cover');
              const coverImageContent = this.coverImage[0];
              let coverImage = {
                contentType: coverImageContent.type, // you can set it based on the type of image you are uploading like image/png
                fileName: coverImageContent.name,
                file: coverImageContent.preview,
              };
              const respCoverImage = await new Uploader().uploadImage(coverImage, percent => this.handleUploadProgressing(percent, 'Profile cover'));
              dataSubmit['profile_cover_art'] = respCoverImage.Location;
            } else if (!empty(values['profile_cover_art'])) {
              dataSubmit['profile_cover_art'] = values['profile_cover_art'].url;
            }

            if (this.hasChange['headshotImage'] || this.hasCropped['headshotImage']) {
              this.handleUploadProgressing(0, 'Headshot');
              // Pastors Headshot
              const headshotImageContent = this.headshotImage[0];
              let headshotImage = {
                contentType: headshotImageContent.type, // you can set it based on the type of image you are uploading like image/png
                fileName: headshotImageContent.name,
                file: headshotImageContent.preview,
              };
              const respHeadshotImage = await new Uploader().uploadImage(headshotImage, percent => this.handleUploadProgressing(percent, 'Headshot'));
              dataSubmit['profile_headshot'] = respHeadshotImage.Location;
            } else if (!empty(values['profile_headshot'])) {
              dataSubmit['profile_headshot'] = values['profile_headshot'].url;
            }

            const paramsRequired = ['profile_description', 'profile_video_embed', 'profile_service_times', 'profile_facebook', 'profile_twitter', 'profile_website', 'use_profile_link', 'cell_phone'];

            paramsRequired.forEach(item => {
              if (!empty(values[item])) {
                dataSubmit[item] = values[item];
              }
            });

            this.typeLoading = 'submit';
            if (!this.isAdmin) {
              await UserService.doUpdateProfile(dataSubmit);
              await this.doInitData();
            } else {
              await AdminService.account.update(this.profile.id, dataSubmit);
              this.$emit('onSuccess');
            }
            this.$notification['success']({
              message: 'Update successful.',
              description: `Your profile was updated successfully.`,
            });
          } catch (ex) {
            console.log(ex);
          } finally {
            this.isLoading = false;
          }
        } else {
          window.parent.scrollTo(0, 0);
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
      this.imageCropped = null;
      if (this.hasChange[this.imgLocation]) {
        switch (this.imgLocation) {
          case 'coverImage':
            this.coverImage = [];
            break;
          case 'headshotImage':
            this.headshotImage = [];
            break;
        }
      }
    },
    handleOk() {
      switch (this.imgLocation) {
        case 'coverImage':
          this.coverImage = [
            {
              ...this.coverImage[0],
              preview: this.imageCropped,
              thumbUrl: this.imageCropped,
            },
          ];
          break;
        case 'headshotImage':
          this.headshotImage = [
            {
              ...this.headshotImage[0],
              preview: this.imageCropped,
              thumbUrl: this.imageCropped,
            },
          ];
          break;
      }
      this.$set(this.hasCropped, this.imgLocation, true);
      this.previewVisible = false;
    },
    handlePreview(file, location) {
      this.imgLocation = location;
      this.previewImage = null;
      this.$nextTick(async () => {
        this.isLoadingCropper = true;
        if (this.hasChange[location] || this.hasCropped[location]) {
          if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
          }
          this.previewImage = file.preview;
        } else {
          this.previewImage = file.url;
        }
        this.previewVisible = true;
      });
    },
    handleChange({ fileList }, location) {
      this.imgLocation = location;
      if (!empty(fileList)) {
        this.$set(this.hasChange, location, true);
        const image = new Image();
        image.src = URL.createObjectURL(fileList[0].originFileObj);
        image.onload = () => {
          // const { minWidth, minHeight } = this.defaultSize();
          // if (image.height < minHeight || image.width < minWidth) {
          //   this.$notification['error']({
          //     message: 'Image error',
          //     description: `Please choose image have size greater ${minHeight}px,${minWidth}px (height,width)`,
          //   });
          //   return;
          // }
          switch (location) {
            case 'coverImage':
              this.coverImage = fileList;
              break;
            case 'headshotImage':
              this.headshotImage = fileList;
              break;
          }
          this.handlePreview(fileList[0], location);
        };
      } else {
        switch (location) {
          case 'coverImage':
            this.coverImage = [];
            this.form.setFieldsValue({
              profile_cover_art: {},
            });
            break;
          case 'headshotImage':
            this.headshotImage = [];
            this.form.setFieldsValue({
              profile_headshot: {},
            });
            break;
        }
      }
    },
    beforeUpload(file) {
      return false;
    },
    onCropperReady() {
      this.isLoadingCropper = false;
    },
  },
};
</script>
<style lang="scss">
.profile {
  &.mobile {
    .editr--toolbar {
      height: 100%;
      flex-wrap: wrap;
      .vw-btn-separator {
        display: none;
      }
    }
    .ant-card-body {
      .ant-upload-list-item-actions {
        left: 25px;
        top: calc(100% + 20px);
        opacity: 1;
        i {
          color: rgba(#000, 0.8);
          opacity: 1;
          font-size: 20px;
        }
        > a {
          margin-right: 10px;
        }
      }
    }
  }
  .ant-card-body {
    .coverImage {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 937px;
        max-height: 341px;
      }
    }
    .headshotImage {
      .ant-upload-list-picture-card .ant-upload-list-item,
      .ant-upload-list-picture-card-container,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
      .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
        width: 100%;
        height: 100%;
        max-width: 190px;
        max-height: 250px;
      }
    }
    .ant-upload-list-item-actions {
      i {
        font-size: 26px;
        width: auto;
      }
    }
  }
}
.ant-modal-root.editProfile .ant-modal-body {
  .ant-spin-spinning {
    display: block;
    margin: auto;
  }
}
.select-from-gallery {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
  > span {
    width: initial;
  }
}
</style>
